// ie: Engine.ui.misc();
jQuery(function ($) {
  "use strict";
  var Engine = {
    ui: {
      misc: function () {
        AOS.init();

        $(function () {
          // Add .scrolled class to header when scroll position > 250px
          $(window).on("scroll", function () {
            if ($(this).scrollTop() > 250) {
              $("header").addClass("scrolled");
            } else {
              $("header").removeClass("scrolled");
            }
          });

          // Smooth scroll for anchor links
          $('a[href^="#"]').on("click", function (e) {
            e.preventDefault();

            // Get the target element
            var target = $(this.hash);
            if (target.length) {
              // Animate scroll to target with 100px offset
              $("html, body").animate(
                {
                  scrollTop: target.offset().top - 100,
                },
                800
              );

              // Update URL without the hash
              if (history.pushState) {
                history.pushState(null, null, " ");
              } else {
                location.hash = "";
              }
            }
          });

          if (
            $(".goals-slider").length &&
            !$(".goals-slider").hasClass("slick-initialized")
          ) {
            $(".goals-slider").slick({
              dots: false,
              arrows: false,
              infinite: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: false,
              draggable: false,
              fade: true,
            });
          }

          $(".gotoslide").on("click", function (e) {
            e.preventDefault();
            var slideno = $(this).data("slide");
            $(".goals-slider").slick("slickGoTo", slideno - 1);

            // Remove active class from all gotoslide elements
            $(".gotoslide").removeClass("active");

            // Add active class to clicked element if it doesn't have it
            if (!$(this).hasClass("active")) {
              $(this).addClass("active");
            }
          });

          if (
            $(".mobile-brands-slider").length &&
            !$(".mobile-brands-slider").hasClass("slick-initialized")
          ) {
            $(".mobile-brands-slider").slick({
              dots: false,
              arrows: false,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: "100px",
              autoplay: true,
              autoplaySpeed: 2000,
            });
          }

          if (
            $(".services-slider").length &&
            !$(".services-slider").hasClass("slick-initialized")
          ) {
            $(".services-slider").slick({
              dots: false,
              arrows: true,
              infinite: false,
              slidesToShow: 4,
              slidesToScroll: 1,
              autoplay: true,
              autoplaySpeed: 3000,
              prevArrow: ".services-prev",
              nextArrow: ".services-next",
              touchThreshold: 10000,
              responsive: [
                {
                  breakpoint: 1280,
                  settings: {
                    infinite: true,
                    variableWidth: true,
                    slidesToShow: 1,
                  },
                },
              ],
            });

            // Filter service slides by default on load
            $(".services-slider").slick("slickFilter", ".service");
          }

          $(".filter button").on("click", function () {
            var filter = $(this).data("filter");
            // Remove active class from all filter buttons
            $(".filter button").removeClass("active");
            // Add active class to clicked button
            $(this).addClass("active");

            if ($(".services-slider").hasClass("slick-initialized")) {
              $(".services-slider").slick("slickUnfilter");

              if (filter == "service") {
                $(".services-slider").slick("slickFilter", ".service");
              } else if (filter == "industry") {
                $(".services-slider").slick("slickFilter", ".industry");
              }
            }
          });

          if (
            $(".services-slider2").length &&
            !$(".services-slider2").hasClass("slick-initialized")
          ) {
            $(".services-slider2").slick({
              dots: false,
              arrows: true,
              infinite: false,
              slidesToShow: 4,
              slidesToScroll: 1,
              autoplay: true,
              autoplaySpeed: 3000,
              touchThreshold: 5000,
              variableWidth: false,
              responsive: [
                {
                  breakpoint: 1280,
                  settings: {
                    infinite: true,
                    slidesToShow: 1,
                    variableWidth: true,
                  },
                }
              ],
            });
          }

          if (
            $(".image-slider").length &&
            !$(".image-slider").hasClass("slick-initialized")
          ) {
            $(".image-slider").slick({
              dots: true,
              arrows: false,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              fade: true,
              autoplay: true,
            });
          }

          // Refresh image slider when tab button is clicked
          $(".tab-btn").on("click", function () {
            setTimeout(function () {
              $(".image-slider").slick("setPosition");
            }, 0);
          });

          // Initialize only the first .image-slider2, and scope arrows to within parent container
          $(".image-slider2").each(function () {
            var $slider = $(this);
            if (!$slider.hasClass("slick-initialized")) {
              // Find prev/next within the nearest parent (should be outside slider in block markup)
              var $parent = $slider
                .closest(
                  "[x-show], [data-slider-parent], section, .slider-wrapper"
                )
                .first();
              var $prev = $parent.find(".image-prev");
              var $next = $parent.find(".image-next");
              $slider.slick({
                dots: false,
                arrows: true,
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                prevArrow: $prev.length ? $prev : ".image-prev",
                nextArrow: $next.length ? $next : ".image-next",
                touchThreshold: 1000,
                responsive: [
                  {
                    breakpoint: 1280,
                    settings: {
                      slidesToShow: 3,
                    },
                  },
                  {
                    breakpoint: 768,
                    settings: {
                      slidesToShow: 2,
                    },
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 1,
                      variableWidth: true,
                      infinite: true,
                    },
                  },
                ],
              });
            }
          });

          // Refresh image slider when tab button is clicked
          $(".tab-btn").on("click", function () {
            setTimeout(function () {
              $(".image-slider2").slick("setPosition");
            }, 0);
          });
          if (
            $(".testimonials-slider").length &&
            !$(".testimonials-slider").hasClass("slick-initialized")
          ) {
            $(".testimonials-slider").slick({
              dots: false,
              arrows: true,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: true,
              prevArrow: ".testimonials-prev",
              nextArrow: ".testimonials-next",
            });
          }

          if (
            $(".collection-slider").length &&
            !$(".collection-slider").hasClass("slick-initialized")
          ) {
            $(".collection-slider").slick({
              dots: false,
              arrows: true,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: true,
              variableWidth: true,
              touchThreshold: 10000,
              prevArrow: ".collection-prev",
              nextArrow: ".collection-next",
            });
          }

          $(".collection-filter button").on("click", function () {
            var filter = $(this).data("filter");
            // Remove active class from all filter buttons
            $(".collection-filter button").removeClass("active");
            // Add active class to clicked button
            $(this).addClass("active");

            $(".collection-slider").slick("slickUnfilter");

            if (filter == "proban") {
              $(".collection-slider").slick("slickFilter", ".proban");
            } else if (filter == "megatec") {
              $(".collection-slider").slick("slickFilter", ".megatec");
            }
          });

          if (
            $(".industries-slider").length &&
            !$(".industries-slider").hasClass("slick-initialized")
          ) {
            $(".industries-slider").slick({
              dots: false,
              arrows: true,
              infinite: false,
              slidesToShow: 4,
              slidesToScroll: 1,
              autoplay: true,
              autoplaySpeed: 3000,
              prevArrow: ".industries-prev",
              nextArrow: ".industries-next",
              responsive: [
                {
                  breakpoint: 1280,
                  settings: {
                    infinite: true,
                    variableWidth: true,
                    slidesToShow: 1,
                  },
                },
              ],
            });
          }

          if (
            $(".freshclean-slider").length &&
            !$(".freshclean-slider").hasClass("slick-initialized")
          ) {
            $(".freshclean-slider").slick({
              dots: false,
              arrows: true,
              infinite: false,
              slidesToShow: 4,
              slidesToScroll: 1,
              autoplay: true,
              autoplaySpeed: 3000,
              prevArrow: ".freshclean-prev",
              nextArrow: ".freshclean-next",
              responsive: [
                {
                  breakpoint: 1280,
                  settings: {
                    infinite: true,
                    variableWidth: true,
                    slidesToShow: 1,
                  },
                },
              ],
            });
          }

          if (
            $(".partners-slider").length &&
            !$(".partners-slider").hasClass("slick-initialized")
          ) {
            $(".partners-slider").slick({
              dots: false,
              arrows: false,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              variableWidth: true,
              autoplay: true,
              autoplaySpeed: 3000,
              touchThreshold: 5000,
            });
          }

          if (
            $(".foundations-slider").length &&
            !$(".foundations-slider").hasClass("slick-initialized")
          ) {
            $(".foundations-slider").slick({
              dots: false,
              arrows: false,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              variableWidth: true,
              autoplay: true,
              autoplaySpeed: 3000,
              touchThreshold: 5000,
            });
          }

          if (
            $(".foundation-cards-slider").length &&
            !$(".foundation-cards-slider").hasClass("slick-initialized")
          ) {
            $(".foundation-cards-slider").slick({
              dots: false,
              arrows: true,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              variableWidth: true,
              autoplay: true,
              autoplaySpeed: 3000,
              touchThreshold: 5000,
              prevArrow: ".foundation-cards-prev",
              nextArrow: ".foundation-cards-next",
            });
          }

          if (
            $(".sustainable-bg-slider").length &&
            !$(".sustainable-bg-slider").hasClass("slick-initialized")
          ) {
            $(".sustainable-bg-slider").slick({
              dots: false,
              arrows: false,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: true,
              autoplaySpeed: 2000,
              fade: true,
              asNavFor: ".sustainable-caption-slider",
            });
          }

          if (
            $(".sustainable-caption-slider").length &&
            !$(".sustainable-caption-slider").hasClass("slick-initialized")
          ) {
            $(".sustainable-caption-slider").slick({
              dots: false,
              arrows: false,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: true,
              autoplaySpeed: 2000,
              fade: true,
              asNavFor: ".sustainable-bg-slider",
            });
          }

          if (
            $(".ev-movement-slider").length &&
            !$(".ev-movement-slider").hasClass("slick-initialized")
          ) {
            $(".ev-movement-slider").slick({
              dots: false,
              arrows: false,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: true,
              autoplaySpeed: 2000,
              fade: true,
            });
          }

          if (
            $(".blog-posts-slider").length &&
            !$(".blog-posts-slider").hasClass("slick-initialized")
          ) {
            $(".blog-posts-slider").slick({
              dots: false,
              arrows: false,
              infinite: true,
              slidesToShow: 4,
              slidesToScroll: 1,
              responsive: [
                {
                  breakpoint: 1280,
                  settings: {
                    variableWidth: true,
                    slidesToShow: 1,
                  },
                },
              ],
            });
          }

          if (
            $(".teams-slider").length &&
            !$(".teams-slider").hasClass("slick-initialized")
          ) {
            $(".teams-slider").slick({
              dots: false,
              arrows: true,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              variableWidth: true,
              autoplay: false,
              touchThreshold: 5000,
              nextArrow: ".teams-next",
              prevArrow: ".teams-prev",
            });
          }

          if (
            $(".legacy-img-slider").length &&
            !$(".legacy-img-slider").hasClass("slick-initialized")
          ) {
            $(".legacy-img-slider").slick({
              dots: false,
              arrows: false,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              fade: true,
              autoplay: true,
            });
          }

          if (
            $(".legacy-slider").length &&
            !$(".legacy-slider").hasClass("slick-initialized")
          ) {
            $(".legacy-slider").slick({
              dots: false,
              arrows: true,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              prevArrow: ".legacy-prev",
              nextArrow: ".legacy-next",
              fade: true,
            });
          }

          if (
            $(".artboard-slider").length &&
            !$(".artboard-slider").hasClass("slick-initialized")
          ) {
            $(".artboard-slider").slick({
              dots: false,
              arrows: false,
              infinite: true,
              slidesToShow: 5,
              slidesToScroll: 1,
              responsive: [
                {
                  breakpoint: 1280,
                  settings: {
                    variableWidth: true,
                    slidesToShow: 1,
                  },
                },
              ],
            });
          }

          if (
            $(".cutting-edge-slider").length &&
            !$(".cutting-edge-slider").hasClass("slick-initialized")
          ) {
            $(".cutting-edge-slider").slick({
              dots: false,
              arrows: true,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: "100px",
              variableWidth: true,
              cssEase: "linear",
              autoplay: true,
              autoplaySpeed: 1,
              speed: 6000,
            });
          }

          // Update all a.job-btn matching the old APPLY NOW button requirements to the new input field

          // When .job-btn is clicked, set its data-position value into the correct input field
          $("a.job-btn").on("click", function (e) {
            e.preventDefault();

            var position = $(this).attr("data-position") || "";

            // Find the correct input (by name and classes, as described)
            // Scope: search nearest .wpcf7 form, or fallback to closest form in DOM tree
            var $form = $(this).closest("form");
            if ($form.length === 0) {
              $form = $("form");
            }

            var $input = $form.find(
              'input[name="your-position"]'
            );
            // If not found in form, search globally as fallback
            if ($input.length === 0) {
              $input = $(
                'input[name="your-position"]'
              );
            }
            $input.val(position).trigger("input");
          });

          var map;
          var markers = [];
          var locations = {
            "New Zealand": [
              {
                name: "Location 1",
                lat: -36.8485,
                lng: 174.7633,
                address: "Auckland, New Zealand",
              },
            ],
            Australia: [
              {
                name: "Location 2",
                lat: -33.8688,
                lng: 151.2093,
                address: "Sydney, Australia",
              },
            ],
            America: [
              {
                name: "Location 3",
                lat: 40.7128,
                lng: -74.006,
                address: "New York, USA",
              },
            ],
            Asia: [
              {
                name: "Location 4",
                lat: 35.6762,
                lng: 139.6503,
                address: "Tokyo, Japan",
              },
            ],
            Europe: [
              {
                name: "Location 5",
                lat: 51.5074,
                lng: -0.1278,
                address: "London, UK",
              },
            ],
          };

          function initMap() {
            var mapElement = $("#map")[0];
            if (!mapElement) {
              console.warn("Map element not found");
              return;
            }

            map = new google.maps.Map(mapElement, {
              zoom: 2,
              center: { lat: 20.5937, lng: 78.9629 },
            });

            // Show one marker for each country
            for (var country in locations) {
              if (locations.hasOwnProperty(country)) {
                var loc = locations[country][0]; // First location from each country
                createMarker(loc, country);
              }
            }
          }

          function createMarker(location, country) {
            if (!map || !location) {
              console.warn("Map or location not available for marker creation");
              return;
            }

            var marker = new google.maps.Marker({
              position: { lat: location.lat, lng: location.lng },
              map: map,
              title: location.name,
            });

            google.maps.event.addListener(marker, "click", function () {
              if (map) {
                map.setZoom(5); // Zoom in on the country
                map.setCenter(marker.getPosition());

                // Update the list to show all locations for this country
                updateLocationList(country);
              }
            });

            markers.push(marker);
          }

          function updateLocationList(country) {
            var locationListDiv = $("#location-list");
            if (!locationListDiv.length) {
              console.warn("Location list element not found");
              return;
            }

            locationListDiv.empty(); // Clear current list

            if (locations[country] && locations[country].length > 0) {
              locations[country].forEach(function (location) {
                var locationElement = $("<li></li>")
                  .addClass(
                    "location-item px-4 py-2 bg-gray-100 rounded-lg hover:bg-gray-200 cursor-pointer"
                  )
                  .text(location.name + " - " + location.address)
                  .click(function () {
                    if (map) {
                      map.setCenter({ lat: location.lat, lng: location.lng });
                      map.setZoom(10); // Zoom into the location
                    }
                  });
                locationListDiv.append(locationElement);
              });
            }
          }

          // Filter locations by country
          $("#filter-nz").click(function () {
            filterLocations("New Zealand");
          });
          $("#filter-au").click(function () {
            filterLocations("Australia");
          });
          $("#filter-us").click(function () {
            filterLocations("America");
          });
          $("#filter-asia").click(function () {
            filterLocations("Asia");
          });
          $("#filter-europe").click(function () {
            filterLocations("Europe");
          });

          function filterLocations(country) {
            if (!map) {
              console.warn("Map not available for filtering");
              return;
            }

            // Remove all markers from the map
            markers.forEach(function (marker) {
              if (marker && marker.setMap) {
                marker.setMap(null);
              }
            });
            markers = [];

            // Place markers for all locations in the selected country
            if (locations[country] && locations[country].length > 0) {
              locations[country].forEach(function (location) {
                createMarker(location, country);
              });

              // Zoom in on the first location for the selected country
              var firstLocation = locations[country][0];
              if (firstLocation) {
                map.setZoom(5);
                map.setCenter({
                  lat: firstLocation.lat,
                  lng: firstLocation.lng,
                });
              }
            }

            // Update the location list on the right
            updateLocationList(country);
          }

          // Initialize map when DOM is ready
          if (
            typeof google !== "undefined" &&
            google.maps &&
            $("#map").length > 0
          ) {
            initMap();
          }

          // Function to initialize admission form
          function initConsultationForm(form) {
            const steps = form.querySelectorAll(".form-step");
            const progressBar = form.querySelector(".progress-status");
            const progressSteps = form.querySelectorAll(
              ".progress-steps .step"
            );

            let currentStep = 1;

            // Next button handler
            form.querySelectorAll(".btn-next").forEach((button) => {
              button.addEventListener("click", async (event) => {
                const currentStepElement = event.target.closest(".form-step");
                const stepNumber = parseInt(
                  currentStepElement.dataset.step,
                  10
                );

                // Validate current step fields
                const isValid = await validateStep(currentStepElement);

                if (isValid) {
                  goToStep(stepNumber + 1);
                }
              });
            });

            // Previous button handler
            form.querySelectorAll(".btn-prev").forEach((button) => {
              button.addEventListener("click", (event) => {
                const currentStepElement = event.target.closest(".form-step");
                const stepNumber = parseInt(
                  currentStepElement.dataset.step,
                  10
                );

                if (stepNumber > 1) {
                  goToStep(stepNumber - 1);
                }
              });
            });

            // Reset your-account and your-business when existing-customer radio changes
            form.querySelectorAll(
              'input[type="radio"][name="existing-customer"], input[type="radio"][name="exisiting-customer"]'
            ).forEach((radio) => {
              radio.addEventListener("change", () => {
                const accountField = form.querySelector('[name="your-account"]');
                const businessField = form.querySelector(
                  '[name="your-business"]'
                );
                [accountField, businessField].forEach((field) => {
                  if (field) {
                    field.value = "";
                    field.classList.remove("wpcf7-not-valid");
                    field.removeAttribute("aria-invalid");
                    const errorSpan = field.parentElement?.querySelector(
                      ".wpcf7-not-valid-tip"
                    );
                    if (errorSpan) errorSpan.remove();
                  }
                });
              });
            });

            // Validate step fields using Contact Form 7 validation
            async function validateStep(stepElement) {
              const form = stepElement.closest("form");

              // your-account and your-business: only one required; if one is valid, skip the other
              const accountField = form.querySelector('[name="your-account"]');
              const businessField = form.querySelector('[name="your-business"]');
              const accountValue = accountField?.value?.trim() || "";
              const businessValue = businessField?.value?.trim() || "";
              const accountValid = !!accountValue;
              const businessValid = !!businessValue;
              const eitherValid = accountValid || businessValid;

              // Get all required fields and fields with aria-invalid in current step
              const requiredFields = stepElement.querySelectorAll(
                '[aria-required="true"], [aria-invalid="true"]'
              );
              let isValid = true;

              requiredFields.forEach((field) => {
                const fieldName = field.getAttribute("name");
                const isAccountOrBusiness =
                  fieldName === "your-account" || fieldName === "your-business";

                // Exception: if one of your-account/your-business is valid, skip the other
                if (isAccountOrBusiness && eitherValid) {
                  const errorSpan = field.parentElement?.querySelector(
                    ".wpcf7-not-valid-tip"
                  );
                  if (errorSpan) errorSpan.remove();
                  field.classList.remove("wpcf7-not-valid");
                  field.removeAttribute("aria-invalid");
                  return;
                }

                const value = field.value.trim();
                const isAriaInvalid =
                  field.getAttribute("aria-invalid") === "true";

                // Remove error messages only when aria-invalid is false
                const errorSpan = field.parentElement.querySelector(
                  ".wpcf7-not-valid-tip"
                );
                if (errorSpan && !isAriaInvalid) {
                  errorSpan.remove();
                }
                if (!isAriaInvalid) {
                  field.classList.remove("wpcf7-not-valid");
                }

                // Validate: invalid if empty (required) or aria-invalid is true
                const isInvalid = !value || isAriaInvalid;
                if (isInvalid) {
                  isValid = false;
                  field.classList.add("wpcf7-not-valid");
                  field.setAttribute("aria-invalid", "true");
                  // Only add error tip if we removed it (aria-invalid was false)
                  if (!isAriaInvalid) {
                    const error = document.createElement("span");
                    error.className = "wpcf7-not-valid-tip";
                    // The wrapper carries the message in the page's language
                    error.textContent =
                      stepElement.closest(".consultation-form")?.dataset
                        .requiredMessage || "This field is required.";
                    field.parentElement.appendChild(error);
                  }
                }
              });

              return isValid;
            }

            // Update progress bar and step indicators
            function goToStep(step) {
              steps.forEach((s) => s.classList.remove("active"));
              form
                .querySelector(`.form-step[data-step="${step}"]`)
                .classList.add("active");

              // Update progress bar
              const progress = ((step - 1) / (steps.length - 1)) * 100;
              progressBar.style.width = `${progress}%`;

              // Update step indicators
              progressSteps.forEach((s, index) => {
                if (index + 1 < step) {
                  s.classList.add("completed");
                  s.classList.remove("active");
                } else if (index + 1 === step) {
                  s.classList.add("active");
                  s.classList.remove("completed");
                } else {
                  s.classList.remove("completed", "active");
                }
              });

              currentStep = step;
            }
          }

          // Initialize all consultation forms on the page
          document.querySelectorAll(".consultation-form").forEach((form) => {
            initConsultationForm(form);
          });

          $(window).on("scroll", function () {
            if ($(this).scrollTop() > 1000) {
              $("#back-top").fadeIn();
              $("#back-top").addClass("active");
            } else {
              $("#back-top").fadeOut();
              $("#back-top").removeClass("active");
            }
          });

          var page = 2; // Start at the second page, as the first set of posts is already loaded
          var loading = false; // Prevent multiple requests from happening at once

          $("#load-more-btn").on("click", function () {
            if (loading) return; // Prevent further requests if a request is already in progress
            loading = true;

            // Store original button text
            var originalText = $(this).text();

            var data = {
              action: "load_more_posts", // Action hook to trigger the AJAX request
              page: page,
              posts_per_page: 12, // Number of posts to load each time
            };

            $.ajax({
              url: ajaxloadmore.ajaxurl,
              type: "POST",
              data: data,
              success: function (response) {
                if (response) {
                  $("#posts-grid").append(response); // Append the new posts to the grid
                  page++; // Increment the page number for the next request
                  loading = false; // Reset the loading state
                  $("#load-more-btn").text(originalText); // Restore original button text

                  // Hide the "Load More" button if all posts are loaded
                  if (response === "") {
                    $("#load-more-btn").hide();
                  }
                }
              },
            });
          });

          $("#back-top").on("click", function () {
            $("body,html").animate(
              {
                scrollTop: 0,
              },
              100
            );
            return false;
          });
        });
      }, // end misc
    }, // end ui
    //utils: {

    //}, // end utils
  };
  Engine.ui.misc();
  //Engine.utils.sliders();
});
